<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div class="d-flex align-center mb-4">
            <v-checkbox class="mr-4" v-model="fields.layoutFullWidth" label="Layout Full Width" dense hide-details />
            <v-checkbox
              v-if="fields.layoutFullWidth"
              v-model="fields.spacingHorizontal"
              label="Spacing Horizontal"
              dense
              hide-details
            />
          </div>
          <ckeditor :editor="editor" v-model="fields['content']" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div>
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Padding" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Padding" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Container Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['background-color']"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['text-color']"
                    name="textColor"
                    label="Text Color"
                    default-color="#000000"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'freestyle-section-editor',
  components: {
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        content: '',
        'text-color': '',
        'background-color': '',
        topPadding: true,
        bottomPadding: true,
        layoutFullWidth: false,
        spacingHorizontal: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFreestyle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
